/** Fixed120Hz active-time accumulator. Frame deltas are milliseconds; long gaps
 * are bounded to100ms, pause discards backlog. Presentation never changes physics. */
export function createSteamClock(seed = 1) {
  let time = 1000,
    accumulator = 0,
    randomSeed = seed >>> 0 || 1,
    visualSeed = (seed ^ 0x9e3779b9) >>> 0;
  return {
    now: () => time,
    random: () => {
      randomSeed = (Math.imul(randomSeed, 1664525) + 1013904223) >>> 0;
      return randomSeed / 4294967296;
    },
    visualRand: (min, max) => {
      visualSeed = (Math.imul(visualSeed, 1664525) + 1013904223) >>> 0;
      return min + (visualSeed / 4294967296) * (max - min);
    },
    pause() {
      accumulator = 0;
    },
    advance(delta, active, update) {
      if (!Number.isFinite(delta) || delta < 0) return;
      accumulator += Math.min(100, delta);
      let steps = 0;
      while (accumulator + 1e-8 >= 1000 / 120 && active() && steps++ < 12) {
        time += 1000 / 120;
        update(1 / 120);
        accumulator -= 1000 / 120;
      }
      if (!active()) accumulator = 0;
    },
  };
}
